import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const SessionUserContext = createContext();

export function SessionUserProvider({ children }) {
  const [localUserName, setLocalUserName] = useState(null);

  const capture = useCallback((name) => {
    if (name) setLocalUserName(name);
  }, []);

  const value = useMemo(() => ({ localUserName, capture }), [localUserName, capture]);

  return (
    <SessionUserContext.Provider value={value}>
      {children}
    </SessionUserContext.Provider>
  );
}

export function useSessionUser() {
  const context = useContext(SessionUserContext);
  if (!context) throw new Error('useSessionUser deve ser usado dentro de SessionUserProvider');
  return context;
}
